/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';

export default class ApplicationFieldValue extends Component {}
